<template>
  <main role="main">
    <div class="bg-pay">
      <core-view />
    </div>
  </main>
</template>

<script>
export default {
  components: {
    CoreView: () => import('@/components/core/guest/View'),
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
  head: {
    bodyAttrs: {
      class: 'hold-transition layout-top-nav',
    },
  },
}
</script>

<style scoped>
.bg-pay {
  min-height: 100%;
}
</style>
